export class VentasDeclaradasPorSolicitudRequest {
    identSolicitud?: number | null;
}